import React, {useEffect, useRef, useState} from 'react';
import main_block_bg from "./images/main_page_bg.svg";
import default_img from "./images/default_img.svg";
import Header from "../components/Header";
import main_bg from "./images/main_bg.png";
import warning_triangle from "./images/warning_triangle.svg";
import about_core_icon1 from "./images/about_core_icon1.svg";
import about_core_icon2 from "./images/about_core_icon2.svg";
import about_core_icon3 from "./images/about_core_icon3.svg";
import about_core_icon4 from "./images/about_core_icon4.svg";
import about_core_icon5 from "./images/about_core_icon5.svg";
import undura_core_logo from "./images/undura_core_logo.svg";
import core_components_logo1 from "./images/core_components_logo1.png";
import core_components_logo2 from "./images/core_components_logo2.png";
import core_components_logo3 from "./images/core_components_logo3.png";
import core_components_logo4 from "./images/core_components_logo4.png";
import technology_icon1 from "./images/technology_icon1.svg";
import technology_icon2 from "./images/technology_icon2.svg";
import technology_icon3 from "./images/technology_icon3.svg";
import technology_icon1_1 from "./images/technology_icon1_1.svg";
import technology_icon1_2 from "./images/technology_icon1_2.svg";
import technology_icon1_3 from "./images/technology_icon1_3.svg";
import technology_icon1_4 from "./images/technology_icon1_4.svg";
import resources_icon1 from "./images/resources_icon1.svg";
import resources_icon2 from "./images/resources_icon2.svg";
import resources_icon3 from "./images/resources_icon3.svg";

import core_components_mob1 from "./images/core_components_mob.png";
import core_components_mob2 from "./images/core_components_mob2.png";
import core_components_mob3 from "./images/core_components_mob3.png";
import core_components_mob4 from "./images/core_components_mob4.png";


import mail_icon from "./images/mail_icon.svg";
import close_icon from "./images/close_icon.svg";
import undura_logo_grad from "./images/undura_core_grad_image.svg";
import for_issuers_core from "./images/for_issuers_core.png";
import for_investors_core from "./images/for_investors_core.png";
import white_logo from "./images/white_logo.svg";
import send_plane_icon from "./images/send_plane.svg";
import inputNameIcon from "./images/userNameIcon.svg";
import inputPencilIcon from "./images/pencilIcon.svg";
import stay_informed_bg_top from "./images/stay_informed_bg_top.svg";
import stay_informed_bg_bottom from "./images/stay_informed_bottom_bg.svg";
import "./undura_core_pixels.css"
import Footer from "../components/Footer";
import problems_icon1 from "../Presentation/images/problems_point_icon1.svg";
import problems_icon2 from "../Presentation/images/problems_point_icon2.svg";
import undura_roadmap from "../MainPage/images/RoadMap.svg";
import problems_icon3 from "../Presentation/images/problems_item_icon3.svg";
import InputContainer from "./components/InputContainer";
import {motion} from "framer-motion";
import {Link} from "react-scroll";
import DevelopmentButton from "../components/DevelopmentButton";
import Roadmap from "../components/ImprovedRoadmap";
import axios from "axios";
import CoreWarning from "./components/CoreWarning";

const UnduraCore = () => {
    const [contactEmail, setContactEmail] = useState("")
    const [contactFullName, setContactFullName] = useState("")
    const [contactMessage, setContactMessage] = useState("")
    const [subscribeValue, setSubscribeValue] = useState("")

    let sendApiContact = () => {
        axios.post("https://api.undura.com/api/v1/contact", {
            full_name: contactFullName,
            email: contactEmail,
            message: contactMessage,
            honeypot: ""
        }).then(r => console.log(r)).catch((er) => console.error(er))
    }
    let sendApiSubscribe = () => {
        axios.post("https://api.undura.com/api/v1/newsletter/subscribe", {
            email: subscribeValue,
            honeypot: ""
        }).then(r => console.log(r)).catch((er) => console.error(er))
    }

    const initial = {opacity: 0, y: 40}
    const whileInView = {opacity: 1, y: 0}
    const transition = {duration: 0.8, ease: "easeOut", delay: 0.1}
    const viewport = {once: true}


    const roadmap = [
        {
            label: "Compilation and verification of documentation: KYC/KYB/AML policies, conflict-of-interest management (Art. 8), KIIS/disclosures, marketing fairness and clarity, agreements with EMI/PI, continuity plan and backup-servicer arrangement (Art. 12), GDPR compliance framework.\n" +
                "Pre-licensing consultations and submission of the application package.",
            date: "ECSPR: Preparation and Application in Lithuania",
            branch: "up",
            open: true
        },

        {
            label: "Completion of the Lite Hub UI and connection to the underlying infrastructure: multi-tenant architecture, Undura ID, transparent non-security donation flows, and recipient reporting.",
            date: "Launch of Lite Interface and Hub",
            branch: "down"
        },
        {
            label: "Definition of service perimeter (e.g., order reception and transmission, secondary layer), best-execution policy, product and client categorization, transaction reporting procedures (RTS/ITS), capital and competency requirements. Compilation of evidence and submission for authorization.",
            date: "MiFID II: Preparation and Application in Germany",
            branch: "up",
            open: true
        },
        {
            label: "Finalization of the core modules: Risk & Compliance, Data Integrity, Continuity & Custody, Settlement & Ledger, Growth & Competence, API & Expansion.\n" +
                "Integration with KYC/EMI providers, resilience testing (RPO/RTO), audit trails, penetration testing, target SLO/SLA.\n" +
                "Preparation for operational and regulatory audits.",
            date: "Completion of Core and Hub Development",
            branch: "down",
            open: true
        },
        {
            label: "Implementation of MiFID II modules: order book, transaction reporting, market abuse monitoring, expansion of Settlement & Ledger Core. Implementation of MiFID II modules: order book, transaction reporting, market abuse monitoring, and expansion of the Settlement & Ledger Core. Completion and testing of the secondary market layer, followed by its official launch after obtaining the MiFID II license.",
            date: "MiFID Modules and Secondary Market",
            branch: "up"
        },
        {
            label: "Technical and legal feasibility study of compatibility: fund structures and risk management (AIFM), financial data access and exchange (FiDA).\n" +
                "Design of adapters, prototype reporting schemes, and data interface alignment.",
            date: "Research of AIFM and FiDA Modules",
            branch: "down",
            open: true
        },
        {
            label: "Localization for neighboring jurisdictions: partnerships with local EMI/KYC providers, data storage and compliance requirements, mapping of reporting and legal structures. Gradual rollout of white-label network nodes in non-EU markets.",
            date: "Expansion Beyond the EU",
            branch: "up"
        },
    ];
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    const onMouseDown = (e) => {
        isDragging.current = true;
        startX.current = e.pageX - wrapperRef.current.offsetLeft;
        scrollLeft.current = wrapperRef.current.scrollLeft;
    };

    const onMouseMove = (e) => {
        if (!isDragging.current) return;
        const x = e.pageX - wrapperRef.current.offsetLeft;
        const walk = x - startX.current;
        wrapperRef.current.scrollLeft = scrollLeft.current - walk;
    };

    const onMouseUp = () => {
        isDragging.current = false;
    };

    const wrapperRef = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleDescription = () => {
        setIsExpanded(!isExpanded);
    };

    const [isExpanded1, setIsExpanded1] = useState(false);
    const toggleDescription1 = () => {
        setIsExpanded1(!isExpanded1);
    };


    const [isExpanded2, setIsExpanded2] = useState(false);
    const toggleDescription2 = () => {
        setIsExpanded2(!isExpanded2);
    };
    const [isExpanded3, setIsExpanded3] = useState(false);
    const toggleDescription3 = () => {
        setIsExpanded3(!isExpanded3);
    };

    const [isExpanded4, setIsExpanded4] = useState(false);
    const toggleDescription4 = () => {
        setIsExpanded4(!isExpanded4);
    };

    const descClasses = `undura_core_desc ${isExpanded ? 'expanded' : ''}`;
    const descClasses1 = `for_issuers_desc ${isExpanded1 ? 'expanded' : ''}`;
    const descClasses4 = `about_core_desc ${isExpanded4 ? 'expanded' : ''}`;
    const forIssuers = `for_issuers_desc ${isExpanded2 ? 'expanded' : ''}`;
    const forIssuers1 = `for_issuers_desc ${isExpanded3 ? 'expanded' : ''}`;


    const [isFocusedTextarea, setIsFocusedTextarea] = useState(false);

    const focusedTextArea = `textarea_bg ${isFocusedTextarea ? 'focused_textarea' : ''}`;
    const fadeInUp = {
        hidden: {opacity: 0, y: 20},
        visible: {opacity: 1, y: 0, transition: {duration: 0.7, ease: "easeOut"}}
    };

    const hoverScale = {scale: 1.05, transition: {type: "spring", stiffness: 250}};
    const fadeInScale = {
        hidden: {opacity: 0, scale: 0.95},
        visible: {opacity: 1, scale: 1, transition: {duration: 0.8, ease: "easeOut"}}
    };

    const blockVariants = {
        hidden: {opacity: 0, y: 30},
        visible: {
            opacity: 1,
            y: 0,
            transition: {duration: 0.8, ease: "easeOut"}
        }
    };


    const staggerVariants = {
        hidden: {opacity: 0, y: 20},
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {duration: 0.6, delay: i * 0.15, ease: "easeOut"}
        })
    };

    const buttonVariants = {
        hidden: {opacity: 0, y: 10},
        visible: {opacity: 1, y: 0, transition: {delay: 1.2, duration: 0.6, ease: "easeOut"}}
    };
    const itemVariants = {
        hidden: {opacity: 0, y: 20},
        visible: {opacity: 1, y: 0, transition: {duration: 0.6, ease: "easeOut"}}
    };

    const techPointVariants = {
        hidden: {opacity: 0, y: 20},
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {duration: 0.6, delay: i * 0.2, ease: "easeOut"}
        })
    };

    const numbersPointVariants = {
        hidden: {opacity: 0, y: 20},
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {duration: 0.6, delay: i * 0.2, ease: "easeOut"}
        })
    };

    const pointVariants = {
        hidden: {opacity: 0, y: 20},
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {delay: i * 0.15, duration: 0.6, ease: "easeOut"}
        })
    };
    const fadeNumeric = {
        initial: "hidden",
        whileInView: "visible",
        viewport: {once: true},
        variants: pointVariants
    };
    // Разные варианты анимации
    const fadeUp = {
        initial: {opacity: 0, y: 40},
        whileInView: {opacity: 1, y: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeDown = {
        initial: {opacity: 0, y: -40},
        whileInView: {opacity: 1, y: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeLeft = {
        initial: {opacity: 0, x: -50},
        whileInView: {opacity: 1, x: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeRight = {
        initial: {opacity: 0, x: 50},
        whileInView: {opacity: 1, x: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };


    const [isExpandedAbout, setIsExpandedAbout] = useState(false);
    const [clampedAbout, setClampedAbout] = useState(true);

    const toggleDescriptionAbout = () => {
        if (isExpandedAbout) {
            setIsExpandedAbout(false);
            setTimeout(() => setClampedAbout(true), 600); // чтобы анимация завершилась перед клэмпингом
        } else {
            setClampedAbout(false);
            setIsExpandedAbout(true);
        }
    };

    const descClassesAbout = `undura_core_desc ${isExpandedAbout ? "expanded" : ""} ${clampedAbout ? "clamped" : ""}`;

    const hoverButton = {
        whileHover: {
            scale: 1.05,
            transition: {type: "spring", stiffness: 300}
        }
    };


    const buttonAnimate = {
        initial: fadeUp.initial,
        whileInView: fadeUp.whileInView,
        viewport: fadeUp.viewport,
        transition: fadeUp.transition,
        whileHover: hoverButton.whileHover
    }


    useEffect(() => {
        const hash = window.location.hash;
        if (!hash) return;

        const el = document.querySelector(hash);
        if (!el) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                window.history.replaceState(null, "", window.location.pathname);
                observer.disconnect();
            }
        }, {threshold: 0.5});

        observer.observe(el);

        setTimeout(() => {
            el.scrollIntoView({behavior: "smooth", block: "center"});
        }, 300);

    }, []);

    return (
        <div className="undura_core">
            <CoreWarning/>
            <img src={main_block_bg} alt="" className="main_block_bg"/>
            <Header mode="core"/>

            <motion.div className="powered_by"
                        {...fadeUp}
            >
                <div className="circle"></div>
                Powered by Undura Core
            </motion.div>

            <motion.div className="main_text"
                        {...fadeLeft}
            >
                {window.innerWidth < 768 ? (
                    <>Unified Infrastructure<br/><span>for Regulated Investment Systems</span></>
                ) : (
                    <><span>Unified Infrastructure</span><br/>for Regulated Investment Systems</>
                )}
            </motion.div>

            <motion.div className="about_undura_main"
                        {...fadeRight}
            >
                Modular, compliant, and scalable architecture for digital fundraising, asset issuance, and financial
                participation platforms.
            </motion.div>

            <motion.div className="main_block_buttons"
                        {...fadeUp}
            >
                <a href="#core_components">
                    <motion.div className="get_started" whileHover={hoverScale}>
                        System Overview
                    </motion.div>
                </a>
                <DevelopmentButton className="explore_demo">
                    View Resources
                </DevelopmentButton>
            </motion.div>

            <motion.div className="main_bg_block"
                        {...fadeUp}
            >

                <img src={main_bg} alt="" className="main_bg"/>
            </motion.div>

            <div className="about_undura_core">
                <motion.div className="about_undura_core_info"
                            {...fadeLeft}
                >
                    <div className="about_undura_name">
                        <span>About</span> Undura
                    </div>
                    <motion.div
                        id="about-undura"
                        className={descClassesAbout}
                        onClick={toggleDescriptionAbout}
                        layout
                    >
                        The idea for Undura emerged while developing the BrixWise concept — a platform built to
                        distribute fractional income from individual real estate projects.<br/>
                        Under ECSPR, that model was limited by Article 8, which restricts direct income-sharing
                        structures.<br/>
                        This constraint exposed a broader challenge: the need for regulatory infrastructure that could
                        remain compliant yet flexible across different business models.<br/>
                        Undura was created to meet that need — as a neutral foundation for building and operating
                        regulated investment systems.<br/>
                        It brings compliance, data integrity, and operational security to the surface, while keeping
                        flexibility as a first-class principle rather than a compromise.<br/>
                        The platform follows a simple belief: financial infrastructure should be transparent, neutral,
                        and adaptive.<br/>
                        By making these qualities explicit and accessible, Undura enables institutions and innovators to
                        work within clear rules — and still explore new ways to apply them.<br/>
                    </motion.div>
                    <motion.div className="read_more_button" onClick={toggleDescriptionAbout}>
                        {isExpandedAbout ? "Read less:" : "Read more"}
                    </motion.div>

                </motion.div>

                <motion.div className="about_undura_image"
                            {...fadeRight}
                >
                    <img src={undura_logo_grad} alt=""/>
                </motion.div>
            </div>
            <motion.div className="main_text"
                        {...fadeLeft}
            >
                <span>About</span> Core
            </motion.div>

            <motion.div className={descClasses4}
                        {...fadeRight}
            >
                Undura Core is the first generation of Undura’s regulated infrastructure — a
                unified foundation that merges the principles of CSP (Crowdfunding Service Provider)
                and Securities Platform into one compliant framework.
            </motion.div>
            {/* <div className="read_more_button" onClick={toggleDescription4}>
                Read more
            </div>*/}

            <div className="about_core_points">
                <motion.div custom={0} className="about_core_point" {...fadeNumeric}>
                    <div className="icon_number">
                        <img src={about_core_icon1} alt=""/>
                        <div className="number_core">01</div>
                    </div>
                    <div className="about_core_point_name">Modularity</div>
                    <div className="about_core_point_desc">
                        Composable system architecture enabling selective deployment and isolation of functional layers
                        according to licensing scope and operational needs.
                    </div>
                </motion.div>

                <motion.div custom={1} className="about_core_point" {...fadeNumeric}>
                    <div className="icon_number">
                        <img src={about_core_icon2} alt=""/>
                        <div className="number_core">02</div>
                    </div>
                    <div className="about_core_point_name">Security</div>
                    <div className="about_core_point_desc">
                        End-to-end encryption, enforced access control, and adherence to enterprise-grade security
                        frameworks aligned with EU financial-sector standards.
                    </div>
                </motion.div>

                <motion.div custom={2} className="about_core_point" {...fadeNumeric}>
                    <div className="icon_number">
                        <img src={about_core_icon3} alt=""/>
                        <div className="number_core">03</div>
                    </div>
                    <div className="about_core_point_name">Scalability</div>
                    <div className="about_core_point_desc">
                        Horizontally extensible infrastructure designed to maintain stable throughput and data integrity
                        under regulated transaction volumes.
                    </div>
                </motion.div>

                <motion.div custom={3} className="about_core_point" {...fadeNumeric}>
                    <div className="icon_number">
                        <img src={about_core_icon4} alt=""/>
                        <div className="number_core">04</div>
                    </div>
                    <div className="about_core_point_name">Transparency</div>
                    <div className="about_core_point_desc">
                        Immutable audit trails and verifiable records ensure traceability, accountability, and
                        compliance with ECSPR and MiFID reporting obligations.
                    </div>
                </motion.div>

                <motion.div custom={4} className="about_core_point" {...fadeNumeric}>
                    <div className="icon_number">
                        <img src={about_core_icon5} alt=""/>
                        <div className="number_core">05</div>
                    </div>
                    <div className="about_core_point_name">Interoperability</div>
                    <div className="about_core_point_desc">
                        Designed for cross-system regulatory frameworks — enabling adaptation between ECSPR, MiFID II,
                        AIFM, FiDA and future regimes without structural change to the Core.
                    </div>
                </motion.div>
            </div>
            <motion.a className="view_architecture_button" href="/architecture" {...buttonAnimate}>
                View Architecture
            </motion.a>
            <div className="initiate_inquiry">

                <motion.div className="initiate_inquiry_name"{...fadeLeft}>
                    <span>Initiate</span> Inquiry
                </motion.div>


                <motion.div className="initiate_inquiry_desc"{...fadeRight}>
                    <div className="first_desc">
                        Undura Core supports multiple levels of collaboration within its regulatory framework.
                    </div>
                    <div className="second_desc">
                        Other partnership structures can be developed based on regulatory status, operational scope, or
                        technology integration requirements.
                    </div>
                </motion.div>
            </div>

            <div className="initiate_inquiry_points">
                <motion.div className="problems_point" {...fadeLeft}>
                    <div className="icon_number">
                        <img src={about_core_icon1} alt=""/>
                        <div className="number_core">01</div>
                    </div>
                    <div className="problems_item_name">Co-branded Partnerships</div>
                    <div className="problems_item_desc">
                        Strategic alliances where organizations operate their own platforms
                        powered by Undura infrastructure. These arrangements extend network capacity while
                        maintaining unified standards of compliance and data security.
                    </div>
                </motion.div>

                <motion.div className="problems_point" {...fadeRight}>
                    <div className="icon_number">
                        <img src={about_core_icon2} alt=""/>
                        <div className="number_core">02</div>
                    </div>
                    <div className="problems_item_name">Client Platforms</div>
                    <div className="problems_item_desc">
                        Issuers or institutions using Undura as a white-label environment for regulated fundraising and
                        investor operations. Each platform functions independently under its own brand while relying on
                        the Core layer for compliance and transaction integrity.
                    </div>
                </motion.div>
            </div>

            <motion.div className="main_text" {...fadeLeft}>
                <span>Core</span> Components
            </motion.div>
            <a id="core_components"></a>


            <div className="core_components" id="core-components">
                <div className="core_components_points">
                    <motion.div className="core_components_point" {...fadeNumeric} custom={0}
                    >
                        <div className="core_components_logo">

                            {window.innerWidth < 768 ? <img src={core_components_mob1} alt=""/> :
                                <img src={core_components_logo1} alt=""/>}
                        </div>
                        <div className="core_components_desc">
                            Regulatory compliance automation including KYC/AML verification, document management, and
                            real-time compliance monitoring systems.
                        </div>
                    </motion.div>

                    <motion.div className="core_components_point" {...fadeNumeric} custom={1}
                    >
                        <div className="core_components_logo">
                            {window.innerWidth < 768 ? <img src={core_components_mob2} alt=""/> :
                                <img src={core_components_logo2} alt=""/>}
                        </div>
                        <div className="core_components_desc">
                            Payment processing infrastructure, multi-currency support, escrow management, and
                            integration with major payment service providers.
                        </div>
                    </motion.div>

                    <motion.div className="core_components_point" {...fadeNumeric} custom={2}
                    >
                        <div className="core_components_logo">
                            {window.innerWidth < 768 ? <img src={core_components_mob3} alt=""/> :
                                <img src={core_components_logo3} alt=""/>}
                        </div>
                        <div className="core_components_desc">
                            Business operations suite including campaign management, investor relations, reporting
                            dashboards, and workflow automation.
                        </div>
                    </motion.div>

                    <motion.div className="core_components_point" {...fadeNumeric} custom={3}
                    >
                        <div className="core_components_logo">
                            {window.innerWidth < 768 ? <img src={core_components_mob4} alt=""/> :
                                <img src={core_components_logo4} alt=""/>}
                        </div>
                        <div className="core_components_desc">
                            Distributed data architecture with blockchain integration, analytics engine, and secure data
                            warehousing for comprehensive insights.
                        </div>
                    </motion.div>
                </div>

                <motion.img src={undura_core_logo} alt="" className="core_components_points_image"
                            {...fadeUp}
                />
            </div>

            <motion.div
                className="main_text"
                {...fadeLeft}
            >
                Undura <span>Roadmap</span>
            </motion.div>

            <motion.div className="roadmap_fs_block" initial={initial}
                        whileInView={whileInView}
                        transition={transition}
                        viewport={viewport}
                        ref={wrapperRef}
                        onMouseDown={onMouseDown}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseUp}
                        onMouseUp={onMouseUp}
                        style={{
                            overflowX: "auto !important",
                            overflowY: "hidden",
                            //cursor: isDragging.current ? "grabbing" : "grab"
                        }}
            >
                <Roadmap items={roadmap}/>
            </motion.div>


            <motion.div
                className="for_issuers_block"

            >
                <motion.div className="for_issuers" {...fadeLeft}>
                    <div
                        className="about_undura_name"
                    >
                        <span>For </span>Issuers
                    </div>

                    <div
                        className="for_issuers_desc expanded"
                    >
                        Undura Core provides a regulated infrastructure layer for organizations seeking to raise capital
                        under their own brand.<br/>
                        Issuers gain access to a licensed operational environment with built-in investor verification,
                        payment processing, and transparent reporting tools.<br/>
                        The Core framework maintains full compliance with ECSPR standards while allowing each issuer to
                        define its investment model, structure, and presentation.<br/>
                    </div>

                    <motion.a href="/for-issuers"
                              className="view_overview"
                              {...buttonAnimate}
                    >
                        View Issuer Overview
                    </motion.a>
                </motion.div>

                <motion.div
                    className="img_issuers_block"
                    {...fadeRight}
                >
                    <img src={for_issuers_core} alt=""/>
                </motion.div>
            </motion.div>

            <div
                className="for_issuers_block second_mobile"
            >
                <motion.div
                    className="img_issuers_block"
                    {...fadeLeft}
                >
                    <img src={for_investors_core} alt=""/>
                </motion.div>

                <motion.div className="for_issuers" {...fadeRight}>
                    <div
                        className="about_undura_name"
                    >
                        <span>For </span>Investors
                    </div>

                    <div
                        className="for_issuers_desc expanded"
                    >
                        Undura Core establishes a unified access layer for regulated investment participation.<br/>
                        Through Undura ID, investors operate within a verified environment that provides secure identity
                        management, transparent transaction records, and consistent regulatory protection across the
                        network.<br/>
                        Upon expansion under MiFID II, the framework will enable a secondary market layer, allowing
                        compliant cross-platform exchange of securities within the Undura Network.
                    </div>

                    <motion.a href="/for-investors"
                              className="view_overview"
                              {...buttonAnimate}
                    >
                        View Investor Overview
                    </motion.a>
                </motion.div>
            </div>
            <motion.div
                className="main_text"
                {...fadeLeft}
            >
                Technology <span>& Security</span>
            </motion.div>

            <motion.div
                className="about_technology_text"
                {...fadeRight}
            >
                Undura Core is engineered around resilience, data protection, and continuous auditability — aligning
                with European security and compliance standards.
            </motion.div>


            <div className="technology_three_points pb24">
                {[
                    {
                        icon: technology_icon1,
                        name: "Encryption & Key Management",
                        desc: "All sensitive data is encrypted in transit and at rest using AES-256 and TLS 1.3 protocols.<br/>Keys are managed via certified HSM/KMS (e.g., CloudHSM or AWS KMS) with rotation policies and strict role-based access control."
                    },
                    {
                        icon: technology_icon2,
                        name: "Cloud & Resilience",
                        desc: "Deployed across EU cloud regions with multi-zone redundancy and daily backups.<br/>Target recovery metrics: RPO ≤ 1 hour, RTO ≤ 4 hours. Regular restoration testing and automated failover ensure service continuity."
                    },
                    {
                        icon: technology_icon3,
                        name: "Compliance & Audit",
                        desc: "Infrastructure designed in accordance with GDPR, ISO 27001, and SOC 2 Type II frameworks.<br/>Annual external audits, quarterly internal reviews, and immutable audit trails guarantee traceability and accountability."
                    }
                ].map((point, index) => (
                    <motion.div
                        key={index}
                        className="technology_point"
                        custom={index}
                        {...fadeNumeric}
                    >
                        <div className="technology_icon_block">
                            <img src={point.icon} alt=""/>
                        </div>
                        <div className="problems_item_name">
                            {point.name}
                        </div>
                        <div
                            className="problems_item_desc"
                            dangerouslySetInnerHTML={{__html: point.desc}}
                        />
                    </motion.div>
                ))}
            </div>

            <div className="technology_numbers_points">
                {[
                    {icon: technology_icon1_1, number: "99.95%", desc: "Uptime SLA"},
                    {icon: technology_icon1_2, number: "< 100 ms", desc: "API latency (p95)"},
                    {icon: technology_icon1_3, number: "30 days minimum", desc: "Backup retention"},
                    {icon: technology_icon1_4, number: "Annually", desc: "Penetration testing:"}
                ].map((point, index) => (
                    <motion.div
                        key={index}
                        className="technology_numbers_point"
                        custom={index}
                        {...fadeNumeric}
                    >
                        <div className="technology_icon_block">
                            <img src={point.icon} alt=""/>
                        </div>
                        <div className="technology_point_info">
                            <div className="technology_number">{point.number}</div>
                            <div className="technology_point_desc">{point.desc}</div>
                        </div>
                    </motion.div>
                ))}
            </div>
            <motion.a href="/architecture"
                      className="explore_security_button"
                      {...buttonAnimate}
            >
                Explore Security Framework
            </motion.a>

            {/*<motion.div
                className="main_text"
                {...fadeLeft}
            >
                Resources
            </motion.div>

            <div className="resources_three_points">
                {[
                    {
                        icon: resources_icon1,
                        name: "Technical Documentation",
                        desc: "API references, integration guides, SDK documentation, and code examples.",
                        href:"/resources"
                    },
                    {
                        icon: resources_icon2,
                        name: "Compliance Documents",
                        desc: "KYC/AML policies, GDPR statements, security standards, and audit reports.",
                        href:"/resources"
                    },
                    {
                        icon: resources_icon3,
                        name: "Whitepapers & Reports",
                        desc: "Technical whitepapers, industry reports, and detailed case studies.",
                        href:"/resources"
                    }
                ].map((resource, index) => (
                    <motion.div
                        key={index}
                        className="resources_point"
                        custom={index}
                        {...fadeNumeric}
                    >
                        <div className="technology_icon_block">
                            <img src={resource.icon} alt="" />
                        </div>
                        <div className="problems_item_name">{resource.name}</div>
                        <div className="problems_item_desc">{resource.desc}</div>
                        <motion.a className="resources_read_more_button" href = {resource.href} {...buttonAnimate}>Read more</motion.a>
                    </motion.div>
                ))}
            </div>
*/}
            <motion.div
                className="stay_informed_block"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.3}}
                variants={blockVariants}
            >
                <div className="stay_informed_block_info">
                    <img src={stay_informed_bg_top} alt="" className="stay_informed_bg_top"/>
                    <motion.div className="stay_informed_content" initial="hidden" animate="visible">
                        {[
                            "Powered by Undura Core",
                            "Stay informed about Undura Core updates",
                            "Subscribe to receive early access to technical releases, integration notes, and documentation updates.\n\nInformation is shared periodically and limited to infrastructure and regulatory developments."
                        ].map((text, i) => (
                            <motion.div key={i} custom={i} variants={staggerVariants}>
                                {i === 0 ? (
                                    <div className="powered_by">
                                        <div className="circle"></div>
                                        {text}</div>
                                ) : i === 1 ? (
                                    <div className="stay_informed_main">{text}</div>
                                ) : (
                                    <div className="stay_informed_desc">{text}</div>
                                )}
                            </motion.div>
                        ))}
                        <motion.div custom={3} variants={staggerVariants} className="mob_100">
                            <InputContainer inputPlaceholder="your.email@organization.com" inputIcon={mail_icon}
                                            inputType="email"
                                            value={subscribeValue} onChange={(el) => {
                                setSubscribeValue(el.target.value)
                            }}>
                                <div className="send_button" onClick={() => {
                                    sendApiSubscribe()
                                }}>
                                    <img src={send_plane_icon} alt=""/>
                                </div>
                            </InputContainer>
                        </motion.div>
                    </motion.div>
                    <img src={stay_informed_bg_bottom} alt="" className="stay_informed_bg_bottom"/>
                </div>
            </motion.div>


            <motion.div
                className="get_in_touch_full_block"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.3}}
                variants={blockVariants}
            >
                <div className="get_in_touch_block">
                    <motion.div className="get_in_touch_message_block" initial="hidden" animate="visible">
                        <motion.div custom={0} variants={staggerVariants} className="get_in_touch_name">
                            Get in Touch
                        </motion.div>
                        <motion.form className="get_in_touch_form" custom={1} variants={staggerVariants}>
                            <div className="input_name">Full Name<span>*</span></div>
                            <InputContainer inputPlaceholder="James Brown" inputIcon={inputNameIcon} inputType="text"
                                            value={contactFullName} onChange={(e) => {
                                setContactFullName(e.target.value)
                            }}/>
                            <div className="input_name">E-mail<span>*</span></div>
                            <InputContainer inputPlaceholder="hello@undura.com" inputIcon={mail_icon} inputType="text"
                                            value={contactEmail} onChange={(e) => {
                                setContactEmail(e.target.value)
                            }}/>
                            <div className="input_name">Your message<span>*</span></div>
                            <div className="textarea_container">
                                <div className={focusedTextArea}>
                                    <img src={inputPencilIcon} alt=""/>
                                    Type here
                                </div>
                                <textarea className="type_here_textarea" onFocus={() => setIsFocusedTextarea(true)}
                                          onBlur={(e) => {
                                              if (e.target.value.length === 0) setIsFocusedTextarea(false)
                                          }}
                                          value={contactMessage} onChange={(e) => {
                                    setContactMessage(e.target.value)
                                }}
                                />
                            </div>
                            <button className="get_in_touch_form_submit" type="submit"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        sendApiContact()
                                    }}>
                                Submit Inquiry
                            </button>
                        </motion.form>
                    </motion.div>
                    <motion.div className="about_undura_get_in_touch" custom={2} variants={staggerVariants}>
                        <img src={white_logo} alt=""/>
                        <div className="about_undura_get_in_touch_main_text">
                            Reach out to discuss partnership opportunities, platform integration, or other collaboration
                            formats within the Undura ecosystem.
                        </div>
                        <div className="about_undura_get_in_touch_desc">
                            Messages are handled directly by the Core team.
                        </div>
                    </motion.div>
                </div>
            </motion.div>


            <Footer/>
        </div>
    );
};

export default UnduraCore;